import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.bind";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es6.object.assign";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, Children } from 'react';

var Carousel = /*#__PURE__*/function (_Component) {
  _inherits(Carousel, _Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);
    _this.state = {
      slide: props.initialSlide,
      dragging: null,
      sliding: false,
      offset: 0
    };
    _this.setTimer = _this.setTimer.bind(_assertThisInitialized(_this));
    _this.clearTimer = _this.clearTimer.bind(_assertThisInitialized(_this));
    _this.events = {
      onTouchStart: _this.onDraggingStart.bind(_assertThisInitialized(_this)),
      onTouchMove: _this.onDraggingMove.bind(_assertThisInitialized(_this)),
      onTouchEnd: _this.onDraggingEnd.bind(_assertThisInitialized(_this)),
      onTouchCancel: _this.onDraggingEnd.bind(_assertThisInitialized(_this)),
      onClick: _this.onClick.bind(_assertThisInitialized(_this)),
      onTransitionEnd: _this.onTransitionEnd.bind(_assertThisInitialized(_this))
    };
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: "onTransitionEnd",
    value: function onTransitionEnd() {
      var _this2 = this;

      // this will not be triggered when document.hidden
      var slide = this.state.slide;
      var count = Children.count(this.props.children);
      if (slide == count + 1) slide = 1;
      if (slide == 0) slide = count;
      this.setState({
        slide: slide,
        sliding: false
      }, function () {
        _this2.setTimer();

        _this2.props.slideDidChange && _this2.props.slideDidChange(slide);
      });
    }
  }, {
    key: "setTimer",
    value: function setTimer() {
      var interval = this.props.autoPlayInterval;

      if (Children.count(this.props.children) > 1 && interval > 0) {
        this.clearTimer();
        this.timer = window.setInterval(this.changeSlide.bind(this, this.state.slide + 1), interval);
      }
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      window.clearInterval(this.timer);
    }
  }, {
    key: "changeSlide",
    value: function changeSlide(slide) {
      if (document.hidden) return; // run only when page is visible

      if (this.props.slideWillChange && !this.props.slideWillChange(slide, this.state.slide)) return;
      if (slide >= 0 && slide <= React.Children.count(this.props.children) + 1) this.setState({
        slide: slide,
        sliding: true,
        dragging: null,
        offset: 0
      }, this.setTimer);
    }
  }, {
    key: "onDraggingStart",
    value: function onDraggingStart(event) {
      if (event.touches) this.setState({
        dragging: {
          x: event.touches[0].pageX,
          y: event.touches[0].pageY
        },
        offset: 0
      });
    }
  }, {
    key: "onDraggingMove",
    value: function onDraggingMove(event) {
      var _this$state = this.state,
          sliding = _this$state.sliding,
          dragging = _this$state.dragging;
      if (sliding || !dragging || !event.touches) return;
      var x = event.touches[0].pageX;
      var y = event.touches[0].pageY;
      var offset = x - dragging.x;
      if (Math.abs(y - dragging.y) < Math.abs(offset)) event.preventDefault();
      this.setState({
        offset: offset
      });
    }
  }, {
    key: "onDraggingEnd",
    value: function onDraggingEnd(event) {
      var sliderWidth = event.currentTarget.clientWidth;
      var _this$state2 = this.state,
          slide = _this$state2.slide,
          offset = _this$state2.offset,
          dragging = _this$state2.dragging;
      if (!dragging) return;
      var target = Math.abs(offset) > sliderWidth / 5 ? offset > 0 ? slide - 1 : slide + 1 : slide;
      this.setState({
        dragging: null
      }, this.changeSlide.bind(this, target));
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      if (Math.abs(this.state.offset) < 25) return; // trigger click in a small distance

      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          switcher = _this$props.switcher,
          indicator = _this$props.indicator,
          transitionDuration = _this$props.transitionDuration,
          transitionTimingFunction = _this$props.transitionTimingFunction,
          slideWillChange = _this$props.slideWillChange,
          slideDidChange = _this$props.slideDidChange;
      var props = Object.assign({}, this.props); // rest parameters is not available before node 8

      delete props.children;
      delete props.autoPlayInterval;
      delete props.switcher;
      delete props.indicator;
      delete props.transitionDuration;
      delete props.transitionTimingFunction;
      delete props.slideWillChange;
      delete props.slideDidChange;
      delete props.initialSlide;
      var _this$state3 = this.state,
          slide = _this$state3.slide,
          sliding = _this$state3.sliding,
          dragging = _this$state3.dragging,
          offset = _this$state3.offset;
      var slides = Children.map(children, function (child) {
        return React.cloneElement(child, {
          key: child.key + '_clone'
        });
      });
      var count = Children.count(children);
      var enabled = count > 1;
      var goPrevSlide = this.changeSlide.bind(this, slide - 1);
      var goNextSlide = this.changeSlide.bind(this, slide + 1);
      var slideStyle = {
        flexBasis: '100%',
        flexShrink: 0
      };
      return React.createElement('div', _extends({}, props, {
        style: Object.assign({}, props.style, {
          position: 'relative',
          overflowX: 'hidden',
          touchAction: 'pan-y pinch-zoom'
        })
      }), React.createElement('ul', _extends({
        style: {
          listStyleType: 'none',
          padding: 0,
          margin: 0,
          display: 'flex',
          transitionProperty: sliding ? 'transform' : 'none',
          transform: enabled ? offset !== 0 ? 'translateX(calc(' + offset * 1 + 'px - ' + slide * 100 + '%))' : 'translateX(-' + slide * 100 + '%)' : null,
          transitionDuration: transitionDuration,
          transitionTimingFunction: transitionTimingFunction,
          contain: 'layout',
          willChange: 'transform'
        }
      }, this.events), enabled && Children.map(slides.slice(-1).concat(children, slides.slice(0, 1)), function (item, index) {
        return React.createElement('li', {
          'aria-current': slide === index,
          style: slideStyle
        }, item);
      }) || React.createElement('li', null, children)), enabled && indicator && React.createElement('ol', null, Children.map(children, function (item, index) {
        return React.createElement('li', {
          'aria-current': slide === index + 1,
          onClick: _this3.changeSlide.bind(_this3, index + 1)
        }, index + 1);
      })), enabled && switcher && React.createElement('div', null, React.createElement('button', {
        type: 'button',
        className: 'prev',
        onClick: goPrevSlide
      }), React.createElement('button', {
        type: 'button',
        className: 'next',
        onClick: goNextSlide
      })));
    }
  }]);

  return Carousel;
}(Component);

Carousel.defaultProps = {
  className: 'slider',
  transitionDuration: '.8s',
  transitionTimingFunction: 'ease-in-out',
  initialSlide: 1 // slide index start from 1

};
export default Carousel;